import { createApp } from 'vue';
import App from './App.vue';
import "../node_modules/vue-dawn-flow/dawn-flow.css";
import dawnFlow from "vue-dawn-flow"
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

const app = createApp(App);

app.use(dawnFlow)
app.use(Antd)
app.mount('#app')